<template>
  <profile-subsection
    action-text="Edit"
    :editing="activeSection === 'Name'"
    :disabled="activeSection && activeSection !== 'Name'"
    @active-action="submit"
    @inactive-action="$emit('set-active')"
    @cancel-action="cancel"
  >
    <template #inactive>
      <p>{{ firstName }}</p>
      <p>{{ email }}</p>
    </template>
    <template #active>
      <label
        class="hidden"
        for="first-name"
      >
        First Name:
      </label>
      <input
        id="first-name"
        v-model="firstName"
        :disabled="submitting"
        type="text"
        name="first-name"
      >
    </template>
    <template #active-disabled>
      <p class="disclaimer">
        {{ email }}
      </p>
      <p class="disclaimer">
        We currently do not support email changes. If you have any questions please contact customer support.
      </p>
    </template>
  </profile-subsection>
</template>

<script>
import ProfileSubsection from '@components/profile/subsection';

export default {
  components: { ProfileSubsection },
  props: {
    activeSection: {
      type: String,
    },
    submitting: {
      type: Boolean,
    },
    user: {
      type: Object,
    },
  },
  emits: ['clear-active', 'set-active', 'set-submitting'],
  data() {
    return {
      email: '',
      firstName: '',
      prevFirstName: '',
    };
  },
  mounted() {
    this.email = this.user.email;
    this.firstName = this.user.firstName;
    this.prevFirstName = this.user.firstName;
  },
  methods: {
    cancel() {
      this.$emit('clear-active');
      this.firstName = this.prevFirstName;
    },
    submit() {
      this.$emit('set-submitting', false);
      const params = {
        user: {
          first_name: this.firstName,
        },
      };

      this.$store.dispatch('session/updateUser', params).then(response => {
        this.$emit('clear-active');
        this.$emit('set-submitting', false);
        this.prevFirstName = this.firstName;

        this.$notify({
          group: 'notifications',
          text: 'Profile Updated',
          type: 'success',
        });
      }).catch(e => {
        this.firstName = this.prevFirstName;
        this.$notify({
          group: 'notifications',
          text: 'Error Updating Profile',
          type: 'error',
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.disclaimer {
  color: #bfbfbf;
  margin: 0 0 0 rem-calc(12);

  &:first-of-type {
    margin-top: rem-calc(24);
  }

  &:not(:first-of-type) {
    font-size: rem-calc(12);
    font-style: italic;
    margin-top: rem-calc(8);
  }
}

</style>
